    var lazy_css = [], lazy_js = [];
    function _debounce(a, b = 300) {
        let c;
        return (...d) => {
            clearTimeout(c), c = setTimeout(() => a.apply(this, d), b)
        }
    }
    window.___mnag = "userA" + (window.___mnag1 || "") + "gent";
    window.___plt = "plat" + (window.___mnag1 || "") + "form";
    try {
        var a = navigator[window.___mnag],
            e = navigator[window.___plt];
        window.__isPSA = (e.indexOf('x86_64') > -1 && a.indexOf('CrOS') < 0), window.___mnag = "!1", c = null
    } catch (d) {
        window.__isPSA = !1;
        var c = null;
        window.___mnag = "!1"
    }
    window.__isPSA = __isPSA;
    if (__isPSA){
        var uLTS = new MutationObserver(mutations => {
                        mutations.forEach(({ addedNodes }) => {
                            addedNodes.forEach(node => {
                                if (node.nodeType === 1 && node.tagName === 'IFRAME') {
                                    node.setAttribute("loading","lazy");
                                    node.setAttribute("data-src",node.src);
                                    node.removeAttribute("src");
                                }
                                if (node.nodeType === 1 && node.tagName === 'IMG') {
                                    imageCount++;
                                    if (imageCount > lazyImages) {
                                        node.remove();
                                    }
                                }
                                if (node.nodeType === 1 && node.tagName === 'LINK') {
                                    if (lazy_css.length) {
                                        lazy_css.forEach(el => {
                                            if(node.href.includes(el)) {
                                                node.setAttribute("data-href",node.href);
                                                node.removeAttribute("href");
                                            }
                                        });
                                    }
                                }
                                if (node.nodeType === 1 && node.tagName === 'SCRIPT') {
                                    node.setAttribute('data-src', node.src);
                                    node.removeAttribute('src');
                                    node.type = 'text/lazyload';
                                }
                            })
                        })
                    });
        var imageCount = 0, lazyImages = 2;
    } else {
        var uLTS = new MutationObserver(mutations => {
                    mutations.forEach(({ addedNodes }) => {
                        addedNodes.forEach(node => {
                            if (node.nodeType === 1 && node.tagName === 'IFRAME') {
                                node.setAttribute("loading","lazy");
                                node.setAttribute("data-src",node.src);
                                node.removeAttribute("src");
                            }
                            if (node.nodeType === 1 && node.tagName === 'IMG') {
                                imageCount++;
                                if (imageCount > lazyImages) {
                                    node.setAttribute("loading","lazy");
                                }
                            }
                            if (node.nodeType === 1 && node.tagName === 'LINK') {
                                if (lazy_css.length) {
                                    lazy_css.forEach(el => {
                                        if(node.href.includes(el)) {
                                            node.setAttribute("data-href",node.href);
                                            node.removeAttribute("href");
                                        }
                                    });
                                }
                            }
                            if (node.nodeType === 1 && node.tagName === 'SCRIPT') {
                                if (lazy_js.length) {
                                    lazy_js.forEach(el => {
                                        if(node.src.includes(el)) {
                                            node.setAttribute("data-src",node.src);
                                            node.removeAttribute("src");
                                        }
                                    });
                                }
                                if (node.innerHTML.includes('asyncLoad')) {
                                    node.innerHTML = node.innerHTML.replace('if(window.attachEvent)', 'document.addEventListener(\'asyncLazyLoad\',function(event){asyncLoad();});if(window.attachEvent)').replaceAll(', asyncLoad', ', function(){}');
                                }
                                if (node.innerHTML.includes('PreviewBarInjector') || node.innerHTML.includes('adminBarInjector')) {
                                    node.innerHTML = node.innerHTML.replace('DOMContentLoaded', 'loadBarInjector');
                                }
                            }
                        })
                    })
                });
        var imageCount = 0, lazyImages = 20;
    }
    uLTS.observe(document.documentElement, {childList: true, subtree: true});